// Original just for the recording of approval
export var ActionApprovalLogType;
(function (ActionApprovalLogType) {
    ActionApprovalLogType["APPROVED"] = "approved";
    ActionApprovalLogType["APPROVAL_REVERTED"] = "approval_reverted";
    ActionApprovalLogType["SKIPPED"] = "skipped";
    /** A pending action was run immediately via "Action Now" */
    ActionApprovalLogType["RUN_NOW"] = "run_now";
    /** Action was created by a user via an adhoc/manual send */
    ActionApprovalLogType["CREATED_ADHOC"] = "created_adhoc";
})(ActionApprovalLogType || (ActionApprovalLogType = {}));
//# sourceMappingURL=actionApprovalLog.js.map